const MEDIA_ITEMS = [
  {
    id: 1,
    title: '《暗影猎手》动画化决定PV',
    desc: '人气热血漫画《暗影猎手》正式宣布动画化，首支预告片震撼发布！',
    duration: '02:38',
    views: '28.6万',
    img: 'https://readdy.ai/api/search-image?query=Anime%20trailer%20thumbnail%20style%2C%20dark%20warrior%20with%20glowing%20eyes%20in%20action%20pose%2C%20dramatic%20orange%20and%20black%20color%20scheme%2C%20Japanese%20anime%20promotional%20art%2C%20cinematic%20lighting%20with%20lens%20flares%2C%20professional%20anime%20key%20visual%20quality&width=600&height=340&seq=media-01-shadow&orientation=landscape',
  },
  {
    id: 2,
    title: '十月新番推荐：不可错过的5部漫改',
    desc: '精选十月漫改新番，从热血到治愈，总有一部适合你的口味。',
    duration: '05:12',
    views: '15.3万',
    img: 'https://readdy.ai/api/search-image?query=Anime%20autumn%20season%20promotional%20collage%2C%20multiple%20character%20silhouettes%20with%20warm%20autumn%20colors%2C%20orange%20and%20gold%20leaves%2C%20Japanese%20anime%20style%2C%20cozy%20and%20exciting%20atmosphere%2C%20clean%20composition&width=600&height=340&seq=media-02-october&orientation=landscape',
  },
  {
    id: 3,
    title: '漫画创作幕后：专访《星辰变》作者',
    desc: '走进热门漫画的创作世界，聆听作者讲述角色背后的故事与灵感来源。',
    duration: '08:45',
    views: '12.1万',
    img: 'https://readdy.ai/api/search-image?query=Manga%20artist%20studio%20workspace%2C%20drawing%20table%20with%20sketches%20and%20tools%2C%20warm%20lamp%20light%2C%20creative%20atmosphere%2C%20Japanese%20manga%20artist%20aesthetic%2C%20cozy%20and%20inspiring%20interior%2C%20soft%20natural%20lighting&width=600&height=340&seq=media-03-interview&orientation=landscape',
  },
  {
    id: 4,
    title: '2026年度漫画大赏：最佳作品盘点',
    desc: '年度漫画评选结果揭晓，回顾一年来最受欢迎的漫画作品与作者。',
    duration: '06:20',
    views: '19.8万',
    img: 'https://readdy.ai/api/search-image?query=Anime%20award%20ceremony%20style%20illustration%2C%20trophy%20with%20spotlight%2C%20gold%20and%20warm%20amber%20tones%2C%20elegant%20Japanese%20anime%20art%20style%2C%20festive%20and%20celebratory%20atmosphere%2C%20sparkling%20confetti%20effects%2C%20red%20carpet%20vibe&width=600&height=340&seq=media-04-awards&orientation=landscape',
  },
  {
    id: 5,
    title: '经典回顾：影响一代人的十大漫画',
    desc: '盘点那些年陪伴我们成长的经典漫画，每一部都是青春的印记。',
    duration: '10:15',
    views: '22.4万',
    img: 'https://readdy.ai/api/search-image?query=Nostalgic%20anime%20style%20illustration%2C%20stack%20of%20classic%20manga%20volumes%20with%20warm%20vintage%20tones%2C%20soft%20sepia%20and%20cream%20colors%2C%20Japanese%20retro%20manga%20aesthetic%2C%20sentimental%20and%20warm%20atmosphere%2C%20memory%20lane%20composition&width=600&height=340&seq=media-05-classic&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            漫影推荐
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            漫画相关精彩视频与内容推荐，解锁更多漫迷世界
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {MEDIA_ITEMS.slice(0, 3).map((item) => (
            <div
              key={item.id}
              className="group rounded-xl overflow-hidden border border-background-200/70 bg-background-50 hover:border-accent-200 transition-all duration-300"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </span>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 text-xs rounded bg-background-950/70 text-background-50">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1.5 line-clamp-2">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 mb-2">{item.desc}</p>
                <span className="text-xs text-foreground-500">
                  <i className="ri-eye-line mr-1"></i>{item.views} 次观看
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {MEDIA_ITEMS.slice(3).map((item) => (
            <div
              key={item.id}
              className="group rounded-xl overflow-hidden border border-background-200/70 bg-background-50 hover:border-accent-200 transition-all duration-300 flex flex-col sm:flex-row"
            >
              <div className="relative sm:w-48 flex-shrink-0 h-36 sm:h-auto overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                    <i className="ri-play-fill text-lg ml-0.5"></i>
                  </span>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 text-xs rounded bg-background-950/70 text-background-50">
                  {item.duration}
                </span>
              </div>
              <div className="flex-1 p-4 flex flex-col justify-center">
                <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1.5">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed mb-2">{item.desc}</p>
                <span className="text-xs text-foreground-500">
                  <i className="ri-eye-line mr-1"></i>{item.views} 次观看
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}